<template>
  <div>
    <Card style="margin-bottom: 15px;">
      <div-date-time />
      <h1 style="text-align: center;padding: 30px">欢迎使用</h1>
    </Card>
  </div>
</template>

<script>
import DivDateTime from '../../../components/div-date-time'

import InforCard from '_c/info-card'
import ItemInfo from '../../../components/item-info/item-info'
import countTo from 'vue-count-to'
export default {
  name: 'home',
  components: {
    ItemInfo,
    DivDateTime,

    InforCard,
    countTo
  },
  data () {
    return {
      startWork: false,
      sale: {
        quantity: 0,
        amount: 0,
        count: 0
      },
      inforCardData: [
        { title: '新增用户', icon: 'md-person-add', count: 803, color: '#2d8cf0' },
        { title: '累计点击', icon: 'md-locate', count: 232, color: '#19be6b' },
        { title: '新增问答', icon: 'md-help-circle', count: 142, color: '#ff9900' },
        { title: '分享统计', icon: 'md-share', count: 657, color: '#ed3f14' }
      ]
    }
  },
  methods: {
    startWorkBtn () {
      this.startWork = true
    }
  }
}
</script>

<style lang="less">
.count-style{
  font-size: 50px;
}
</style>
